import React, {useState} from "react";
import {useDispatch} from "react-redux";
import Form from "./CreateBreakageReportForm.js";
import {cancelCreateBreakageReport} from "../../actions/ShippingApiActions";
import {LIST_TERRITORIES} from "../../queries/shipping";
import {useQuery} from "react-apollo";
import Loading from "../../components/Loading.js";
import GraphQLErrors from "../../components/GraphQLErrors.js";
import {fromJS, Map} from "immutable";
import {showDatePicker} from "../../actions/ViewActions.js";
import {validatePresence} from "../../lib/Validators.js";
import {createBreakageReport} from "../../lib/api/ShippingApi.js";


export default function CreateBreakageReportFormContainer({ shopId }) {
  const [errors, setErrors] = useState([]);
  const dispatch = useDispatch();

  const { loading, error, data } = useQuery(LIST_TERRITORIES, {
    fetchPolicy: "network-only"
  });

  if (loading) return <Loading />;
  if (error) return <GraphQLErrors error={error} />;

  const territories = fromJS(data.territories);

  async function handleSubmit(values) {
    const { shopId, minDate, maxDate } = values.toJS();

    const params = new URLSearchParams({
      shopId,
      minDate,
      maxDate
    });

    try {
      const response = await createBreakageReport(params);

      console.log('Response headers:', response);
      if (!response.ok) {
        setErrors(Map({_error: `HTTP error! status: ${response.status}`}));
      }
      
      // The response header 
      // Load up the content in a blob so we know when it's fully downloaded
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `breakage-report-${shopId || "all"}-from-${minDate}-to-${maxDate}.xlsx`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      // Don't close popup if user wants to generate several reports for similar dates
    } catch (error) {
      console.error('Download failed:', error);
      setErrors(Map({_error: "Failed to generate breakage report. Please try again."}));
    }
  }

  function handleCancel() {
    dispatch(cancelCreateBreakageReport());
  }

  return (
    <div>
      <p>Create a breakage report for the selected Jurisdiction and within the specified date range.</p>
      <Form
        errors={errors}
        validate={validateForm}
        onSubmit={handleSubmit}
        onCancel={handleCancel}
        territories={territories}
        initialValues={{ shopId }}
        showDatePicker={(field, date, options) => dispatch(showDatePicker(field, date, options))}
      />
    </div>
  )
}

function validateForm(values, props) {
  let errors = Map();
  errors = validatePresence(errors, values, "minDate");
  errors = validatePresence(errors, values, "maxDate");
  return errors.toJS();
}